import React from 'react';
import { 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import TimelineIcon from '@mui/icons-material/Timeline';
import StarIcon from '@mui/icons-material/Star';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import ExploreIcon from '@mui/icons-material/Explore';

// Navigation drawer width
const drawerWidth = 240;

// Styled drawer component
const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.default,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

// Selected item style
const SelectedListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.action.selected,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const EnNavigation = ({ currentView, onNavItemClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Navigation items definition
  const navItems = [
    { id: 'timeline', text: 'Timeline View', icon: <TimelineIcon /> },
    { id: 'favorites', text: 'Favorites', icon: <StarIcon /> },
    { id: 'keywords', text: 'Keywords', icon: <BookmarkIcon /> },
    { id: 'discovery', text: 'Discovery', icon: <ExploreIcon /> },
  ];

  // Render navigation items
  const renderNavItems = () => {
    return navItems.map((item) => {
      const ListItemComponent = currentView === item.id ? SelectedListItem : ListItem;
      
      return (
        <ListItemComponent 
          button 
          key={item.id}
          onClick={() => onNavItemClick(item.id)}
        >
          <ListItemIcon>
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemComponent>
      );
    });
  };

  // Temporary drawer for mobile, permanent for desktop
  const variant = isMobile ? 'temporary' : 'permanent';

  return (
    <StyledDrawer
      variant={variant}
      anchor="left"
      open={!isMobile || false} // For mobile, need to manage open/close state separately
    >
      <List>
        {renderNavItems()}
      </List>
      <Divider />
    </StyledDrawer>
  );
};

export default EnNavigation; 